import { useDataState } from './useData';

export function useHorizontalMenu() {
  const [horizontalMenu = true ] = useDataState('horizontalMenu');
  return {
    horizontalMenu
  };
}
